// extracted by mini-css-extract-plugin
export default {"description":"HtmlContent_description_nmDk7"};